// VENDAS — assinatura digital pelo motor de envelopes (2026-08-21).
//
// Substitui o `acao_d4sign` que ia embutido no PUT do documento. Aqui é action
// própria, como todo o resto do sistema, e o backend responde 410 para quem
// ainda mandar o formato antigo (aba aberta desde antes do deploy).

import axios from 'axios';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import type { SignatarioEnvio, StatusAssinatura } from '../../components/assinatura/tipos';

async function chamar<T = any>(action: string, body: Record<string, any> = {}): Promise<T> {
  const token = await getToken();
  const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
    { action, ...body },
    { headers: { Authorization: token } });
  return r.data.body ? JSON.parse(r.data.body) : r.data;
}

/** Quem o sistema SUGERE como signatário (contato do cliente + vendedor). */
export const sugestaoSignatarios = (id: string) =>
  chamar<{
    signatarios: SignatarioEnvio[]; numero: string | null; aviso: string | null;
    /** O que vai ANEXADO ao documento assinado (17/09/2026): o Anexo I com o
     *  escopo técnico, os entregáveis e o cronograma da proposta de origem.
     *  Pedido do Lucas: tem de ficar evidente ANTES de enviar. */
    anexo?: { tem: boolean; proposta: string | null; secoes: string[]; documento_atualizado?: boolean };
  }>(
    'venda_assinatura_sugestao', { id });

export const enviarVendaParaAssinatura = (id: string, p: {
  signatarios: SignatarioEnvio[]; workflow?: boolean; mensagem?: string;
}) => chamar<{ envelope_id: string; signatarios: number }>('venda_assinar', { id, ...p });

/** Lê do NOSSO banco (quem fala com a D4 Sign é o cron) — pode chamar à vontade. */
export const statusAssinaturaVenda = (id: string) =>
  chamar<StatusAssinatura>('venda_assinatura_status', { id });

/**
 * Consulta a D4 Sign NA HORA (o cron é o piso, de 15 min). Devolve o mesmo
 * formato do status, já atualizado. Recusa com 429 se alguém acabou de
 * consultar: a cota padrão da conta é de 10 requisições/hora, e clique
 * repetido custa o envio de outra pessoa.
 */
export const verificarAssinaturaVenda = (id: string) =>
  chamar<StatusAssinatura>('venda_assinatura_verificar', { id });

/** Cancela também no cofre da D4 Sign — sem isso o documento segue assinável. */
export const cancelarAssinaturaVenda = (id: string, motivo?: string) =>
  chamar<{ cancelado: boolean }>('venda_assinatura_cancelar', { id, motivo });
/** Conclui um envio que FALHOU depois de o documento já ter subido ao cofre da
 *  D4 Sign, sem subir outra vez. Reenviar pelo caminho normal criaria uma
 *  segunda via assinável — o servidor recusa com 409 (30/09/2026). */
/** Troca quem assina num documento JÁ enviado à D4 Sign, sem cancelar e sem
 *  perder a assinatura de quem já assinou. Quem entra herda o papel de quem
 *  sai e recebe o link; mudar o PAPEL continua exigindo cancelar e reenviar. */
export const trocarSignatarioVenda = (id: string, p: {
  de_email: string; para_nome: string; para_email: string; para_documento?: string;
}) => chamar<any>('venda_assinatura_trocar_signatario', { id, ...p });

export const retomarAssinaturaVenda = (id: string) =>
  chamar<{ retomado: boolean; tentativa: number; etapa: string | null }>(
    'venda_assinatura_retomar', { id });

/** O arquivo que VEIO DA D4 SIGN, nunca uma regeneração. */
export const pdfAssinadoVenda = (id: string) =>
  chamar<{ url: string; key: string; assinado: boolean }>('venda_pdf_assinado', { id });
